<template>
  <div class="index">
    <div class="index_nav">
      <div class="el-icon-back" @click="toggleReturn()"></div>
      <div class="nav_title">{{course_title}}</div>
    </div>

    <!--    -->
    <div class="index_centent">
      <div class="centent_left">
        <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeft">
          <div class="centent_left_keep" v-show="catalog_show">
            <div class="keep_box">
              <div class="keep_box_list" v-for="(item,index) in catalog" :key="index">
                <div class="list_title">{{item.name}}</div>
                <div class="list_name" :class="[listQuery.file_id===t.id?'active':'']" v-for="(t,cindex) in item.course" :key="cindex" @click="Clickplay(t,item,cindex,index)">
                  <div class="list_name_a">
                    <div class="el-icon-video-camera-solid"></div>
                    <div class="list_name_cent">{{t.name}}</div>
                  </div>
                  <div class="list_name_b">
                    <div class="time">时长：{{t.duration | times}}</div>
                    <div class="dq_status" v-if="listQuery.file_id===t.id">正在学习</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <div class="catalog" @click.stop="toggleCatalog()">
          <div class="el-icon-s-unfold"></div>
          <div class="name">章节</div>
        </div>
        <div class="centent_num">
          <div class="name">目录数</div>
          <div class="num">{{catalog.length}}</div>
        </div>
      </div>
      <div class="player-container">
        <my-video ref="mychild" :videoSrc="src" :isFast="isFast" :logTime="logtime" @getNextSection="getNextSection" @userCourseByOver="userCourseByOver"></my-video>
      </div>
      <div class="centent_right">
        <div class="instructions">
          <div class="title"></div>
          <div class="video_box">
            <div style="color: #3ab06f;font-size: 12px;"></div>
          </div>
          <div class="title"></div>
          <div class="desc"></div>
        </div>
      </div>
    </div>


    <!--     如果是ie浏览器 遮挡    -->
    <div class="ie" v-if="is_support">
      <div class="ie_hint">IE浏览器无法支持课程播放功能，请更换谷歌浏览器或360浏览器(12.0及以上版本)观看。</div>
    </div>

    <!--     如果是微信浏览器 遮挡    -->
    <div class="ie" v-if="is_support_app">
      <div class="ie_hint">请在PC上打开链接，同时使用谷歌浏览器或360浏览器(12.0及以上版本)观看；IE浏览器无法支持课程播放功能。</div>
    </div>


  </div>
</template>

<script>
    import { Base64 } from 'js-base64';
    import MyVideo from '@/components/MyVideo/Index'
    import {GetInfoById} from '@/api/new/course'
    export default {
        name: "videoplay",
        filters: {
            times(duration) {
                let times = Math.floor(duration / 60) + ':' + ((duration % 60) / 100).toFixed(2).slice(-2);
                return times;
            }
        },
        data(){
            return{
                currentTime:0,
                catalog_id:null,
                catalog:[],
                course_title:null,
                logtime:0,
                indexQuery: {
                    tindex: 0,
                    index: 0,
                },
                listQuery: {
                    id: undefined,
                    user_id: undefined,
                },
                is_support: false, //判断是否是ie浏览器
                is_support_wx:false,  //判断是否是微信浏览器
                is_support_app:false, //判断是否是手机浏览器
                id:null,
                catalog_show:false,//左侧目录
                isFast:1,//是否允许快进 1.允许 2.不允许
                src:"",
            }
        },
        mounted() {
            //手机浏览器打开
            if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.is_support_app = true
                return
            }
            //微信浏览器
            let ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                this.is_support_wx = true
            }
            //判断是否IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                // alert("IE浏览器暂不支持播放，请更换谷歌浏览器或360浏览器观看。");
                this.is_support = true
            }
        },
        components:{
            MyVideo,
        },
        created() {
            this.listQuery.id = this.$route.query.id
            this.getinfo()
        },
        methods:{
            getinfo(){
                let that = this
                let temp = {
                    id:that.listQuery.id,
                }
                GetInfoById(temp).then(res=>{
                    if(res.code==20000){
                        let data=Base64.decode(res.data)
                        data=JSON.parse(data);
                        console.log(data,"data")
                        let catalog = data.catalog
                        that.catalog = catalog
                        that.src = catalog[0].course[0].url
                        that.catalog_id = catalog[0].id
                        that.course_title = data.name
                        that.listQuery.file_id = catalog[0].course[0].id
                    }
                })
            },
            //下一节
            getNextSection(){
                let that = this
                let catalog_id = that.catalog_id;
                let course = [];
                let cindex = 0;
                for (let i=0;i<that.catalog.length;i++){
                    if(that.catalog[i].id==catalog_id){
                        course = that.catalog[i].course
                        cindex = i
                        break
                    }
                }
                let index = parseInt(that.indexQuery.index)
                let tindex = parseInt(that.indexQuery.tindex)
                if(course.length>0){
                    if(tindex<course.length-1){
                        let info = course[tindex+1]
                        that.logtime = 0;
                        that.src = info.url
                        that.listQuery.file_id = info.id
                        that.indexQuery.tindex = tindex+1
                        that.indexQuery.index = index
                    }
                    //当前目录已结束，切换下一个新目录第一个视频
                    if(tindex==course.length-1){
                        let info = that.catalog[cindex+1].course[0]
                        that.logtime = 0;
                        that.src = info.url
                        that.catalog_id =  info.catelog_id
                        that.listQuery.file_id = info.id
                        that.indexQuery.tindex = 0
                        that.indexQuery.index = index+1
                    }
                }
            },
            toggleCatalog(){
                this.catalog_show = !this.catalog_show
            },
            //返回上一页
            toggleReturn(){
                this.$router.go(-1)
            },
            //点击单个视频
            Clickplay(e, row, tindex, index){
                let that = this;
                let file_id = that.listQuery.file_id
                if(file_id==e.id){
                    return
                }
                that.logtime = 0;
                that.src = e.url
                that.listQuery.file_id = e.id
                that.catalog_id = e.catelog_id
                that.indexQuery.tindex = tindex
                that.indexQuery.index = index
                that.catalog_show = false//左侧目录
            }
        }
    }
</script>

<style lang="scss" scoped>
  .index{
    .ie {
      position: fixed;
      top: 60px;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ffffff;
      z-index: 999999;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #eee;
      .ie_hint{
        margin: 0 20px;
        font-size: 20px;
      }
    }
    .index_nav{
      background-color: #fff;
      height: 60px;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #333;
      .el-icon-back{
        width: 60px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 25px;
        cursor: pointer;
        color: #999;
        margin-right: 10px;
        &:hover{
          background-color: #f1f3f5;
        }
      }
      .nav_title{
        font-weight: bold;
        font-size: 17px;
      }
    }
    .taking{
      background-color: #3ab06f;
      color: #fff;
      width: 130px;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      text-align: center;
      border-radius: 5px;
      margin: 10px auto;
      font-weight: normal;
      cursor: pointer;
      &:hover{
        opacity: 0.8;
      }
    }
  }
  @media screen and (max-width: 1920px) {
    .index_centent{
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 750px;
      .centent_left{
        width: 5%;
        height:100%;
        background-color: #1c1f21;
        position: relative;
        .centent_left_keep{
          position: absolute;
          left: 100%;
          top: 0;
          bottom: 0;
          height:100%;
          background-color: #26292c;
          width: 400px;
          z-index: 999;
          color: #fff;
          overflow: hidden;
          .keep_box{
            height: 730px;
            padding: 20px 15px;
            width: 380px;
            overflow-y: auto;
            .keep_box_list{
              .list_title{
                font-size: 15px;
                font-weight: bold;
              }
              .list_name{
                margin-left: 10px;
                margin-bottom: 15px;
                margin-top: 15px;
                font-size: 13px;
                color: #9e9fa0;
                cursor: pointer;
                .list_name_a{
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  .el-icon-video-camera-solid{
                    font-size: 16px;
                  }
                  .list_name_cent{
                    margin: 0 5px;
                    /*width: 295px;*/
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                  }
                  .list_name_status{
                    font-size: 12px;
                  }
                }
                .list_name_b{
                  margin-top: 10px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  position: relative;
                  font-size: 12px;
                  .dq_status{
                    position: absolute;
                    right: 15px;
                    top: 0;
                    padding: 2px 10px;
                    border-radius: 3px;
                    color: #fff;
                    background: #3a8ee6;
                  }
                  .time{
                    margin-right: 10px;
                  }
                }
                &:hover{
                  color: #3ab06f;
                }
              }
              .list_name.active{
                color: #3ab06f;
              }
            }
          }
        }
        .catalog{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: auto;
          height: 70px;
          color: #a4a5a6;
          cursor: pointer;
          &:hover{
            background-color: #26292c;
            color: #ffffff;
          }
          .el-icon-s-unfold{
            font-size: 28px;
          }
          .name{
            font-size: 14px;
          }
        }
        .centent_num{
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #fff;
          font-size: 14px;
          margin-top: 5px;
          .num{
            margin: 5px 0;
            color: #67c23a;
            font-weight: bold;
            font-size: 18px;
          }
        }
      }
      .player-container{
        width: 75%;
        height:100%;
      }
      .centent_right{
        width: 20%;
        height:100%;
        background-color: #333;
        .instructions{
          padding: 0 20px;
          margin: 20px auto;
          color: #fff;
          .video_box{
            margin: 20px 0;
            .ta_video{
              width: 300px;
              height: 220px;
            }
          }
          .title{
            margin-bottom: 6px;
            font-weight: 700;
            font-size: 14px;
          }
          .desc{
            font-size: 12px;
            line-height: 24px;
            color: rgba(255,255,255,.6);
            white-space: pre-line;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1300px) {
    .index_centent{
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 480px;
      .centent_left{
        width: 5%;
        height:100%;
        background-color: #333;
        position: relative;
        .centent_left_keep{
          position: absolute;
          left: 100%;
          top: 0;
          bottom: 0;
          height:100%;
          background-color: #26292c;
          width: 400px;
          z-index: 999;
          color: #fff;
          overflow: hidden;
          .keep_box{
            height: 460px;
            padding: 20px 15px;
            width: 380px;
            overflow-y: auto;
            .keep_box_list{
              .list_title{
                font-size: 15px;
                font-weight: bold;
              }
              .list_name{
                margin-left: 10px;
                margin-bottom: 15px;
                margin-top: 15px;
                font-size: 13px;
                color: #9e9fa0;
                cursor: pointer;
                .list_name_a{
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  .el-icon-video-camera-solid{
                    font-size: 16px;
                  }
                  .list_name_cent{
                    margin: 0 5px;
                    /*width: 295px;*/
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                  }
                  .list_name_status{
                    font-size: 12px;
                  }
                }
                .list_name_b{
                  margin-top: 10px;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  position: relative;
                  font-size: 12px;
                  .dq_status{
                    position: absolute;
                    right: 15px;
                    top: 0;
                    padding: 2px 10px;
                    border-radius: 3px;
                    color: #fff;
                    background: #3a8ee6;
                  }
                  .time{
                    margin-right: 10px;
                  }
                }
                &:hover{
                  color: #3ab06f;
                }
              }
              .list_name.active{
                color: #3ab06f;
              }
            }
          }

        }
        .catalog{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: auto;
          height: 70px;
          color: #a4a5a6;
          cursor: pointer;
          &:hover{
            background-color: #26292c;
            color: #ffffff;
          }
          .el-icon-s-unfold{
            font-size: 28px;
          }
          .name{
            font-size: 14px;
          }
        }
      }
      .player-container{
        width: 75%;
        height:100%;
      }
      .centent_right{
        width: 20%;
        height:100%;
        background-color: #333;
        .instructions{
          padding:  0 20px;
          margin: 20px auto;
          color: #fff;
          .video_box{
            margin: 20px 0;
            .ta_video{
              width: 220px;
              height: 180px;
            }
          }
          .title{
            margin-bottom: 6px;
            font-weight: 700;
            font-size: 14px;
          }
          .desc{
            font-size: 12px;
            line-height: 24px;
            color: rgba(255,255,255,.6);
            white-space: pre-line;
          }
        }
      }
    }
  }
</style>